import React, { useRef } from "react";
import { Dropdown, Card, Image, Button, ListGroup } from "react-bootstrap";
import cameraIcon from "../../Assets/svg/camera.svg";
import personIcon from "../../Assets/svg/person_ic.svg";
import lockIcon from "../../Assets/svg/settings.svg";
import helpIcon from "../../Assets/svg/help.svg";
import contactIcon from "../../Assets/svg/support.svg";
import editIcon from "../../Assets/svg/edit_ic.svg";
import logoutIcon from "../../Assets/svg/logout.svg";
import arrowRight from "../../Assets/svg/go_right.svg";
import { updateProfileImageApi, getSwitchAccountApi } from "./topbar-api";
import "./Topbar.css";
import "../common/Util.css";
const ProfilePopup = ({ orgList, profileDetail, onClose, orgLogo, orgName, callProfileFunc }) => {
  const accountsUrl = process.env.REACT_APP_ACCOUNTS_URL;
  const environment = process.env.REACT_APP_ENVIRONMENT;

  const menuItems = [
    {
      icon: personIcon,
      label: "View Profile",
      action: () => window.open(`${accountsUrl}/user-detail`, "_blank", "noopener,noreferrer"),
    },
    {
      icon: lockIcon,
      label: "Change Password",
      action: () => window.open(`${accountsUrl}/user-detail#change-password`, "_blank", "noopener,noreferrer"),
    },
    /*  {
      icon: helpIcon,
      label: "Help Center",
      action: () =>
        window.open(`${accountsUrl}/landing`, "_blank", "noopener,noreferrer"),
    }, */
    {
      icon: contactIcon,
      label: "Contact Us",
      action: () => window.open("https://mawalog.com/say-hello/", "_blank", "noopener,noreferrer"),
    },
  ];
  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    const currentURL = window.location.href;

    const redirectData = {
      redirectPath: currentURL,
      app: "transport",
      ts: Date.now(),
    };

    console.warn("🔐 Saving redirect in window.name:", redirectData);

    // ✅ TAB-SPECIFIC, CROSS-DOMAIN SAFE
    window.name = JSON.stringify(redirectData);
    document.cookie = "mawalog=; path=/; domain=.mawalog.com";
    window.location.href = `${accountsUrl}/login`;
    onClose();
  };
  const fileInputRefProfile = useRef(null);
  const handleFileClick = () => {
    if (fileInputRefProfile.current) {
      fileInputRefProfile.current.click();
    } else {
      console.error("File input is not initialized.");
    }
  };
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file && file.type.startsWith("image/")) {
      const reader = new FileReader();
      reader.onload = () => {
        const base64String = reader.result;
        //setOrgImageBase64(base64String)
        updateProfileImage(base64String);
      };
      reader.readAsDataURL(file);
    } else {
      alert("Please select a valid image file.");
    }
  };
  const updateProfileImage = async (image) => {
    const payload = {
      profile_image: image,
    };
    const response = await updateProfileImageApi(payload);
    if (response.status === 200) {
      if (response.data.success === true) {
        callProfileFunc();
        /* setSnackbarMessage(response.data.message);
                                        setSnackbarStatus(response.data.success);
                                        handleSnackbarShow(); */
      }
    }
  };
  const channel = new BroadcastChannel(`auth_channel_mawalog_${environment}`);
  const getSwitchAccount = async (id) => {
    const response = await getSwitchAccountApi(id);
    if (response.status === 200) {
      if (response.data.success === true) {
        const expiryDate = new Date();
        expiryDate.setHours(expiryDate.getHours() + 24); // Set expiration to 24 hours from now
        localStorage.setItem("userType", response.data.details.user_type);
        if (process.env.REACT_APP_HTTPS_ONLY !== "true") {
          document.cookie = `mawalog=${response.data.details.token}; path=/; domain=.mawalog.com; expires=${expiryDate.toGMTString()}`;
        }
        /*  window.location.reload(); */
        // channel.postMessage("changed");
        window.dispatchEvent(
          new CustomEvent("mawalog_org_changed", {
            detail: "changed",
          }),
        );
      }
    }
  };
  return (
    <div className="position-fixed top-0 start-0 w-100 h-100" style={{ zIndex: 1000, backgroundColor: "transparent" }} onClick={onClose}>
      <Card
        className="position-absolute border-0 shadow"
        style={{
          top: "65px",
          right: "20px",
          width: "320px",
          borderRadius: "20px",
          padding: "16px",
          backgroundColor: "#F9FAFB",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="d-flex flex-column align-items-center text-center mb-3">
          <div className="position-relative mb-2">
            {profileDetail.profile_image ? (
              <Image src={profileDetail.profile_image} roundedCircle style={{ width: "80px", height: "80px", objectFit: "cover" }} />
            ) : (
              <div
                className="fs-32 d-flex justify-content-center align-items-center rounded-circle text-white fw-bold"
                style={{
                  width: "80px",
                  height: "80px",
                  backgroundColor: "#7525B1",
                }}
              >
                {profileDetail?.first_name ? profileDetail.first_name.charAt(0) : ""}
              </div>
            )}
            <div
              className="position-absolute bg-white rounded-circle d-flex justify-content-center align-items-center shadow-sm"
              style={{
                bottom: 0,
                right: 0,
                width: "24px",
                height: "24px",
                cursor: "pointer",
                padding: "0px",
              }}
              onClick={handleFileClick}
            >
              <img src={cameraIcon} alt="Edit" style={{ width: "100%", height: "100%" }} />
            </div>
          </div>
          <input
            ref={fileInputRefProfile}
            type="file"
            accept=".jpg, .jpeg, .png"
            onChange={handleFileChange}
            style={{ display: "none" }} // Hide the actual file input
          />
          <h5 className="fs-18 fw-400 mb-1" style={{ color: "#21272C" }}>
            Hi, {profileDetail.first_name} {profileDetail.last_name}!
          </h5>
          <p className=" fs-13 fw-300 text-muted mb-0" style={{ color: "#8790A1" }}>
            {profileDetail.email}
          </p>
        </div>

        <Dropdown>
          <Dropdown.Toggle id="dropdown-basic" className="w-100 bg-transparent border-0 custom-dropdown-toggle p-0">
            <div
              className="d-flex justify-content-between align-items-center p-2 mb-3 border rounded-5"
              style={{
                cursor: "pointer",
                borderColor: "#FFFFFF",
                backgroundColor: "#FFFFFF",
              }}
            >
              <div className="d-flex align-items-center gap-2 overflow-hidden">
                <div
                  style={{
                    width: "24px",
                    height: "24px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {orgLogo ? (
                    <Image
                      src={orgLogo}
                      roundedCircle
                      style={{
                        width: "24px",
                        height: "24px",
                        objectFit: "cover",
                      }}
                    />
                  ) : (
                    <div
                      className="fs-12 d-flex justify-content-center align-items-center rounded-circle fw-bold"
                      style={{
                        width: "24px",
                        height: "24px",
                        backgroundColor: "#7525B1",
                        color: "white",
                      }}
                      onClick={() => window.open(`${accountsUrl}/org-detail`, "_blank", "noopener,noreferrer")}
                    >
                      {orgName ? orgName.charAt(0).toUpperCase() : "-"}
                    </div>
                  )}
                </div>
                <span className="fs-14 fw-400 text-truncate" style={{ color: "#004BA8" }}>
                  {orgName || "---"}
                </span>
              </div>
              <img src={arrowRight} alt="Expand" style={{ width: "16px", height: "16px" }} />
            </div>
          </Dropdown.Toggle>
          <Dropdown.Menu className="w-100 custom-dropdown-menu" style={{ maxHeight: "240px", overflowY: "auto", overflowX: "hidden" }}>
            {orgList.map((option, index) => (
              <Dropdown.Item className="custom-dropdown-item" key={index} onClick={() => getSwitchAccount(option.id)}>
                <div className="d-flex align-items-center gap-2 overflow-hidden">
                  <div
                    style={{
                      width: "24px",
                      height: "24px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {option.image ? (
                      <Image
                        src={option.image}
                        roundedCircle
                        style={{
                          width: "24px",
                          height: "24px",
                          objectFit: "cover",
                        }}
                      />
                    ) : (
                      <div
                        className="fs-12 d-flex justify-content-center align-items-center rounded-circle fw-bold"
                        style={{
                          width: "24px",
                          height: "24px",
                          backgroundColor: "#7525B1",
                          color: "white",
                        }}
                      >
                        {option.org_name ? option.org_name.charAt(0).toUpperCase() : "-"}
                      </div>
                    )}
                  </div>
                  <span className="fs-14 fw-400 text-truncate" style={{ color: "#004BA8" }}>
                    {option.org_name || "---"}
                  </span>
                </div>
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
        <ListGroup className="mt-2 mb-3 rounded-4 overflow-hidden border">
          {menuItems.map((item, index) => (
            <ListGroup.Item
              key={index}
              action
              onClick={item.action}
              className="d-flex justify-content-between align-items-center border-start-0 border-end-0 border-top-0"
              style={{
                padding: "12px 16px",
                borderBottom: index === menuItems.length - 1 ? "none" : "1px solid #E5E5E5",
                backgroundColor: "white",
              }}
            >
              <div className="d-flex align-items-center gap-3">
                <img src={item.icon} alt={item.label} style={{ width: "20px", height: "20px", opacity: 0.7 }} />
                <span className="fs-13 fw-300 " style={{ color: "#21272C", fontWeight: "500" }}>
                  {item.label}
                </span>
              </div>
              <img src={arrowRight} alt="Expand" style={{ width: "16px", height: "16px" }} />
            </ListGroup.Item>
          ))}
        </ListGroup>

        <div className="d-flex mb-3 border rounded-pill" style={{ borderColor: "#EBEBEB" }}>
          <Button
            variant="light"
            className="fs-14 flex-grow-1 d-flex justify-content-center align-items-center gap-2 border-0 rounded-0 rounded-start-pill"
            onClick={() => window.open(`${accountsUrl}/user-edit`, "_blank")}
            style={{
              fontWeight: "500",
              color: "#21272C",
              backgroundColor: "white",
              padding: "10px 0",
            }}
          >
            <img src={editIcon} alt="Edit" style={{ width: "16px", height: "16px" }} />
            Edit
          </Button>
          <div
            style={{
              width: "1px",
              backgroundColor: "#EBEBEB",
              margin: "8px 0",
            }}
          ></div>
          <Button
            variant="light"
            className="fs-14 flex-grow-1 d-flex justify-content-center align-items-center gap-2 border-0 rounded-0 rounded-end-pill"
            onClick={() => {
              handleLogout();
            }}
            style={{
              fontWeight: "500",
              color: "#FF4444",
              backgroundColor: "white",
              padding: "10px 0",
            }}
          >
            <img src={logoutIcon} alt="Sign out" style={{ width: "16px", height: "16px" }} />
            Sign out
          </Button>
        </div>

        <div className="fs-12 d-flex justify-content-center align-items-center gap-2 text-muted">
          <span onClick={() => window.open("https://mawalog.com/privacy-policy/", "_blank")} style={{ cursor: "pointer" }}>
            Privacy Policy
          </span>
          <span className="fw-bold">•</span>
          <span onClick={() => window.open("https://mawalog.com/terms-condition/", "_blank")} style={{ cursor: "pointer" }}>
            Terms of Service
          </span>
        </div>
      </Card>
    </div>
  );
};

export default ProfilePopup;
